<template>
  <div class="upload system-upload-file">
    <el-upload
      :ref="'upload_'+ type"
      action="#"
      drag
      multiple
      :auto-upload="false"
      :accept="acceptType"
      :limit="availableSlots"
      :disabled="uploading"
      :on-change="handleFile.bind(this,type)"
      :on-remove="handleRemove.bind(this,type)"
      :on-exceed="handleFileExceed.bind(this,type)"
      :file-list="fileList"
    >
      <div>
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          <em style="color:#3855F1">{{ uploading ? 'Uploading...' : 'Click to upload' }}</em>
        </div>
      </div>

    </el-upload>
    <div v-if="uploading" class="parse">
      <div class="upload-summary">Uploading {{ uploadingFilesList.length }} file(s)...</div>
      <div v-for="item in uploadingFilesList" :key="item.file.uid" class="file-upload-item">
        <span class="file-name">{{ item.file.name }}</span>
        <span class="file-progress">{{ item.progress }}%</span>
        <span v-if="item.status === 'success'" class="file-status success">✓</span>
        <span v-else-if="item.status === 'failed'" class="file-status failed">✗</span>
      </div>
    </div>
    <Progress v-if="uploading" :progress="totalProgress" />
  </div>

</template>
<script>
// import { uploadFileShowProgress } from '@/api/components/upload'
import { uploadFileWithProgress } from '@/api/components/upload'
export default {
  name: 'MultipleUploadFile',
  components: {
    Progress: () => import('@/views/components/Progress.vue')
  },
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
    limitNum: {
      type: Number,
      default: 1000
    },
    type: {
      type: [String, Number],
      default: ''
    },
    fileDir: {
      type: String,
      default: 'MERCHANT_RECHARGE'
    },
    acceptType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: [],
      removeFiles: [],
      uploadingFiles: {}, // 正在上传的文件映射 { uid: { file, progress, status } }
      uploading: false,
      uploadStats: { // 上传统计
        total: 0,
        success: 0,
        failed: 0
      },
      processingCount: 0 // 正在处理中的文件数（包括验证中和上传中）
    }
  },
  methods: {
    handleFile(type, file) {
      // 先增加处理计数（防止竞态条件）
      this.processingCount++
      // 立即检查是否超出限制
      const totalCount = this.list.length + this.processingCount
      if (totalCount > this.limitNum) {
        const remaining = this.limitNum - this.list.length
        this.$message.warning(`Cannot upload! Maximum ${this.limitNum} files allowed. You have uploaded ${this.list.length} file(s), can only upload ${remaining} more.`)
        this.removeUploadFile(type, file)
        this.processingCount--
        console.log('[Upload Debug] File rejected - exceeds limit')
        return
      }

      // 文件名空格检查
      if (/\s/g.test(file.name)) {
        this.$message.warning('The file name cannot have spaces, please modify and upload!')
        this.removeUploadFile(type, file)
        this.processingCount--
        return
      }
      // 重名检查
      const findItem = this.list.find(item => item.name === file.name)
      const findInUploading = Object.values(this.uploadingFiles).find(item => item.file.name === file.name)
      if (findItem || findInUploading) {
        this.$message.warning('The file with the same name cannot be uploaded, please upload again!')
        this.removeUploadFile(type, file)
        this.processingCount--
        return
      }

      // 如果是新一批上传，重置统计
      if (!this.uploading) {
        this.uploadStats = { total: 0, success: 0, failed: 0 }
      }

      // 增加总数
      this.uploadStats.total++

      console.log('[Upload Debug] File accepted, starting upload:', file.name)
      // 立即开始异步上传
      this.uploadFile(type, file)
    },
    // 异步上传单个文件
    uploadFile(type, file) {
      const uid = file.uid

      // 添加到上传列表
      this.$set(this.uploadingFiles, uid, {
        file,
        type,
        progress: 0,
        status: 'uploading' // uploading, success, failed
      })

      this.uploading = true

      const params = {}
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', this.fileDir)
      params.data = formData

      // 上传进度回调
      params.onUploadProgress = (progressEvent) => {
        const value = Math.floor((progressEvent.loaded * 100) / (progressEvent.total * 1.05))
        if (this.uploadingFiles[uid]) {
          this.$set(this.uploadingFiles[uid], 'progress', value)
        }
      }

      uploadFileWithProgress(params)
        .then(res => {
          // 检查文件是否已被移除
          if (this.removeFiles.includes(uid)) {
            this.removeFiles = this.removeFiles.filter(id => id !== uid)
            this.$delete(this.uploadingFiles, uid)
            this.uploadStats.total--
            this.processingCount--
            this.checkUploadComplete()
            return
          }

          // 更新状态为成功
          if (this.uploadingFiles[uid]) {
            this.$set(this.uploadingFiles[uid], 'progress', 100)
            this.$set(this.uploadingFiles[uid], 'status', 'success')
          }

          // 增加成功计数
          this.uploadStats.success++

          const { path, ...otherData } = res.data
          this.$emit('change')
          this.$emit('templateFileSuccess', { type, fileName: file.name, relativePath: path, ...otherData })

          // 延迟移除，让用户看到100%
          setTimeout(() => {
            this.$delete(this.uploadingFiles, uid)
            this.removeUploadFile(type, file)
            this.processingCount--
            this.checkUploadComplete()
          }, 500)
        })
        .catch((err) => {
          console.error('Upload error:', err)

          // 更新状态为失败
          if (this.uploadingFiles[uid]) {
            this.$set(this.uploadingFiles[uid], 'status', 'failed')
          }

          // 增加失败计数
          this.uploadStats.failed++

          // 延迟移除失败的文件
          setTimeout(() => {
            this.$delete(this.uploadingFiles, uid)
            this.removeUploadFile(type, file)
            this.processingCount--
            this.checkUploadComplete()
          }, 1000)
        })
    },
    // 检查所有上传是否完成
    checkUploadComplete() {
      if (Object.keys(this.uploadingFiles).length === 0) {
        this.uploading = false

        // 显示汇总提示
        const { total, success, failed } = this.uploadStats
        if (total > 0) {
          // if (failed === 0) {
          //   // 全部成功
          //   if (total === 1) {
          //     this.$message.success('File uploaded successfully')
          //   } else {
          //     this.$message.success(`All ${total} files uploaded successfully`)
          //   }
          // } else if (success === 0) {
          //   // 全部失败
          //   if (total === 1) {
          //     this.$message.error('File upload failed')
          //   } else {
          //     this.$message.error(`All ${total} files upload failed`)
          //   }
          // } else {
          //   // 部分成功
          //   this.$message.warning(`${success} of ${total} files uploaded successfully, ${failed} failed`)
          // }

          // 重置统计
          this.uploadStats = { total: 0, success: 0, failed: 0 }
        }
      }
    },
    removeUploadFile(type = '', file) {
      const uid = file.uid
      if (!this.$refs['upload_' + type]) {
        return
      }
      const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
      if (idx !== -1) {
        this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
      }
    },
    handleRemove(type, file) {
      const uid = file.uid

      // 如果文件正在上传，标记为待移除
      if (this.uploadingFiles[uid]) {
        this.removeFiles.push(uid)
        this.$delete(this.uploadingFiles, uid)
        this.processingCount--
        this.checkUploadComplete()
      }
    },
    handleFileExceed() {
      const uploaded = this.list.length
      if (uploaded >= this.limitNum) {
        this.$message.warning(`Maximum ${this.limitNum} files allowed. You have already uploaded ${uploaded} files. Please delete some files before uploading new ones.`)
      } else {
        const remaining = this.limitNum - uploaded
        this.$message.warning(`You can only upload ${remaining} more file(s). Maximum ${this.limitNum} files in total.`)
      }
    }
  },
  computed: {
    // 计算剩余可上传的文件数量
    availableSlots() {
      const remaining = this.limitNum - this.list.length
      return Math.max(0, remaining)
    },
    // 计算当前上传的文件列表（用于显示）
    uploadingFilesList() {
      return Object.values(this.uploadingFiles)
    },
    // 总体上传进度（所有文件的平均进度）
    totalProgress() {
      const files = this.uploadingFilesList
      if (files.length === 0) return 0
      const total = files.reduce((sum, item) => sum + item.progress, 0)
      return Math.floor(total / files.length)
    }
  }
}
</script>
<style>
.system-upload-file .el-upload-dragger{
  width: 450px;
  height: 130px;
}
.system-upload-file .el-icon-upload{
  font-size: 34px;
  color: #D3D7DF;
  margin: 28px 0 16px;
  line-height: 1;
}
.system-upload-file .el-upload__tip{
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  line-height: 1.5;
}
</style>

<style lang="scss" scoped>
.upload{
  display: inline-block;
}
.btn-update{
  margin-left: 10px;
}
.upload-container{
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  cursor: pointer;
  line-height: 100px;
  vertical-align: top;
  font-size: 12px;
  color: #8c939d;
  .icon-add{
    font-size: 8px;
  }
}
.parse{
  width: 600px;
  margin-top: 20px;
  font-size: 14px;
  color: #606266;
}
.upload-summary{
  font-weight: 500;
  margin-bottom: 12px;
  color: #3855F1;
}
.file-upload-item{
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px solid #f0f0f0;
}
.file-upload-item:last-child{
  border-bottom: none;
}
.file-name{
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
}
.file-progress{
  min-width: 45px;
  text-align: right;
  color: #3855F1;
  font-weight: 500;
  margin-right: 8px;
}
.file-status{
  min-width: 20px;
  text-align: center;
  font-weight: bold;
}
.file-status.success{
  color: #67C23A;
}
.file-status.failed{
  color: #F56C6C;
}
</style>
